export enum PagePermission {
  Management = 'management',
  Roles = 'roles',
  Questionnaires = 'questionnaires',
  Letters = 'letters',
  Answers = 'answers',
  Changelog = 'changelog',
  Dashboard = 'dashboard',
  Support = 'support',
}
